import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=aee1c4d8"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"
import style0 from "./Table.vue?vue&type=style&index=0&id=aee1c4d8&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aee1c4d8')) {
      api.createRecord('aee1c4d8', component.options)
    } else {
      api.reload('aee1c4d8', component.options)
    }
    module.hot.accept("./Table.vue?vue&type=template&id=aee1c4d8", function () {
      api.rerender('aee1c4d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tables/Table.vue"
export default component.exports